// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__K7FI4","buttonTabs":"styles_buttonTabs__k9rA8"};